export default class Behaviours {

    constructor(component, behaviour, response) {
        this.component = component;
        this[behaviour](response);
    }

    reload() {
        window.location.reload();
    }

    redirect(response) {
        window.location.href = response.data.url;
    }

    useResponse(response) {
        this.component.stopProcessingAjaxCall();
        this.component.response = response.data;
    }
}
